import { GET_PROPERTY_DOCUMENTS, RESET_PROPERTY_DOCUMENTS } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface PropertyDocumentsState extends BaseAsyncReducerState {
    propertyDocuments?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: PropertyDocumentsState  = {
    loading: false,
    error: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function propertyDocumentsReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_PROPERTY_DOCUMENTS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_PROPERTY_DOCUMENTS.SUCCESS:
            return {
                ...state,
                propertyDocuments: payload,
                loading: false,
                error: false
            }
        case GET_PROPERTY_DOCUMENTS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_PROPERTY_DOCUMENTS:
            return {
                ...state,
                propertyDocuments: null
            }
        default:
            return state
    }
}

export default propertyDocumentsReducer;
